import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 8,
	viewBox: "0 0 10 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.86425 6.50943L8.93955 1.23907C9.23382 0.734758 8.57252 0.221098 8.15669 0.630992L6.40474 2.35794C5.62592 3.12564 4.37491 3.12546 3.59631 2.35753L1.8461 0.631317C1.43037 0.221288 0.768908 0.73481 1.06308 1.2392L4.13672 6.50924C4.52253 7.17076 5.47829 7.17086 5.86425 6.50943Z",
		fill: "white"
	})
});
export default SvgIconChevronDown;
